import { css } from '@emotion/core'

const webfont = css``

export default webfont
